import Svg from "../../Utils/Svg";

export default function TopBar() {
    return (
        <div className="top-bar">
            <div className="top-bar--left">
                <div className="top-bar--email">
                    <span>{Svg.Email}</span>
                    <span> p_daotao@sgu.edu.vn</span>
                </div>
                <div className="top-bar--phone">
                    <span>{Svg.Phone}</span>
                    <span>028 38352 309</span>
                </div>
            </div>
            <div className="top-bar--right">
                <div className="top-bar--address">
                    <span>{Svg.Location}</span>
                    <span> 273 An Dương Vương, Phường 3, Quận 5, TP.HCM</span>
                </div>
            </div>
        </div>
    )
}